/*
 * Enira — "Make it a Gift" upsell.
 *
 * Delegated at document level (not bound per-widget) so it keeps working
 * after the cart drawer / cart page section gets swapped back in by an
 * AJAX refresh — no rebinding needed after DOM replacement.
 *
 * Flow on any change:
 *   1. POST /cart/update.js — set both gift variant quantities to 0
 *      (clears whichever gift line was there before, if any).
 *   2. If a paid option was chosen, POST /cart/add.js to add that variant
 *      (a real line item, so price/tax roll into the cart total normally).
 *   3. POST /cart/update.js — set cart attributes "Gift Order" / "Gift
 *      Message" so the choice is visible on the order for fulfilment.
 *   4. Refresh every .cart-count badge + re-fetch any Section Rendering
 *      API region on the page (cart drawer, and any element carrying
 *      [data-cart-section-id], e.g. the cart page) so totals/lines stay
 *      in sync without a full reload.
 */
(function () {
  function setStatus(widget, text) {
    var status = widget.querySelector('[data-gift-status]');
    if (!status) return;
    status.textContent = text;
    status.hidden = false;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  function refreshCartUI(cart) {
    if (cart && typeof cart.item_count === 'number') {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    }

    var ids = ['cart-drawer'];
    document.querySelectorAll('[data-cart-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-cart-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });

    fetch('/cart?sections=' + encodeURIComponent(ids.join(',')))
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        Object.keys(data).forEach(function (id) {
          var wrapperId = 'shopify-section-' + id;
          var wrapper = document.getElementById(wrapperId);
          if (!wrapper || !data[id]) return;
          var temp = document.createElement('div');
          temp.innerHTML = data[id];
          var fresh = temp.querySelector('#' + wrapperId) || temp.firstElementChild;
          if (fresh) wrapper.outerHTML = fresh.outerHTML;
        });
      })
      .catch(function () {
        /* section refresh is a nice-to-have; ignore network hiccups */
      });
  }

  function handleGiftChange(radio) {
    var widget = radio.closest('[data-gift-widget]');
    if (!widget) return;

    var standardId = widget.getAttribute('data-standard-variant');
    var premiumId = widget.getAttribute('data-premium-variant');
    var value = radio.value;
    var msgWrap = widget.querySelector('[data-gift-message-wrap]');
    var msgInput = widget.querySelector('[data-gift-message]');

    if (msgWrap) msgWrap.hidden = value === 'none';

    setStatus(widget, 'Updating\u2026');

    var clearUpdates = {};
    clearUpdates[standardId] = 0;
    clearUpdates[premiumId] = 0;

    postJSON('/cart/update.js', { updates: clearUpdates })
      .then(function () {
        if (value === 'none') {
          return postJSON('/cart/update.js', {
            attributes: { 'Gift Order': '', 'Gift Message': '' },
          });
        }

        return postJSON('/cart/add.js', {
          items: [{ id: parseInt(value, 10), quantity: 1, properties: { _gift: 'yes' } }],
        }).then(function () {
          var msgVal = msgInput ? msgInput.value.trim() : '';
          return postJSON('/cart/update.js', {
            attributes: { 'Gift Order': 'Yes', 'Gift Message': msgVal },
          });
        });
      })
      .then(function (cart) {
        setStatus(widget, value === 'none' ? 'Gift wrap removed' : 'Gift wrap added \u2713');
        refreshCartUI(cart);
      })
      .catch(function () {
        setStatus(widget, 'Something went wrong \u2014 please try again.');
      });
  }

  function handleGiftMessageInput(input) {
    clearTimeout(input._giftDebounce);
    input._giftDebounce = setTimeout(function () {
      postJSON('/cart/update.js', { attributes: { 'Gift Message': input.value.trim() } });
    }, 600);
  }

  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-gift-radio]');
    if (radio) handleGiftChange(radio);
  });

  document.addEventListener('input', function (e) {
    var msg = e.target.closest('[data-gift-message]');
    if (msg) handleGiftMessageInput(msg);
  });
})();
